//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let outerStyleHeight = '100vh';
	let outerStylePaddingY = 0;
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
		outerStyleHeight = 'auto';
		outerStylePaddingY = 3;
	}
	//#endregion

	return {
		outerStyle: (bg, mt) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				backgroundImage: `url(${bg})`,
				backgroundPosition: 'center',
				backgroundSize: 'cover',
				padding: `${outerStylePaddingY}rem ${minimumMarginX}rem`,
				height: outerStyleHeight,
				marginTop: mt ? `3rem` : `unset`,
			};
		},
		contentContainer: () => {
			return {
				width: '100%',
				height: 'auto',
				display: 'flex',
				flexDirection: 'column',
				margin: 'auto',
			};
		},
		title: () => {
			return {
				textAlign: 'center',
			};
		},
		genericText: () => {
			return {
				marginTop: '1rem',
				color: `white`,
			};
		},
	};
}

export default Styles;
